import { type FC, useMemo } from 'react';

import { type TType } from '@/repositories/generated/shared/search-offers/entities/publisher/PublisherSchema';

import { useCardOfferPublisherContext } from '../../../context/selectors';
import { PublicationDateContainer } from '../../PublicationDateContainer';
import { PublisherNarrow } from '../components/PublisherNarrow';

const PUBLISHER_TYPE_MAP: Partial<Record<TType, string>> = {
  agency: 'Агентство',
  agent: 'Агент',
  homeowner: 'Собственник',
};

export const PublisherNarrowContainer: FC = () => {
  const {
    name,
    url,
    extendedProperties: { documentsCheckedLabel },
    type,
    typeLabels,
  } = useCardOfferPublisherContext();

  const publisherName = useMemo(() => {
    const publisherTypeText = typeLabels?.[0] || (type ? PUBLISHER_TYPE_MAP[type] : '');

    return `${publisherTypeText} ${name}`.trim();
  }, [name, type, typeLabels]);

  return (
    <PublisherNarrow
      documentsChecked={Boolean(documentsCheckedLabel)}
      name={publisherName}
      publicationDate={<PublicationDateContainer />}
      url={url}
    />
  );
};
